// extracted by mini-css-extract-plugin
module.exports = {"terms-wrapper":"terms-wrapper__1-BI8","terms-header":"terms-header__26G_M","lead-text":"lead-text__3eXcI","terms-of-service":"terms-of-service__2_d3J","header":"header__3M1uN"};